import Vue from 'vue'
import vuetify from './vuetify'
// import store from './store'

import './bootstrap'
import './moment'

const files = require.context('./components/', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

window.addEventListener('load', () => {
	const app = new Vue({
		el: '#app',
		vuetify,
	})
})
